<template>
  <div v-if="isOpen" class="fixed inset-0 z-[1001] flex items-center justify-center p-3 sm:p-6 overflow-hidden">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/80 backdrop-blur-md animate-fade-in"></div>
    
    <!-- Scrollable Modal Container -->
    <div class="relative w-full h-full flex items-center justify-center overflow-y-auto overflow-x-hidden">
      <!-- Modal Container with Centering -->
      <div class="relative w-full max-w-lg sm:max-w-xl min-w-0 animate-scale-in my-auto flex flex-col">
        <div class="rounded-2xl p-[1px] bg-gradient-to-r from-[#213E52]/80 via-[#090D1A]/80 to-[#213E52]/80 shadow-2xl shadow-black/60 flex flex-col">
          <div class="rounded-2xl bg-gradient-to-b from-[#101832]/95 to-[#080C19]/95 glass-panel min-w-0 flex flex-col max-h-[85vh] sm:max-h-[80vh] overflow-y-auto custom-scrollbar"
               style="font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial">
            
            <!-- Scrollable Content Wrapper -->
            <div class="p-4 sm:p-8">

          <!-- Header with Logo/Icon -->
          <div class="flex flex-col items-center text-center mb-6">
            <!-- Decorative Icon -->
            <div class="relative mb-4">
              <div class="h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-gradient-to-br from-sky-500/20 to-blue-600/10 border-2 border-sky-400/30 flex items-center justify-center">
                <svg class="h-10 w-10 sm:h-12 sm:w-12 text-sky-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>

            <!-- Title -->
            <h2 class="bg-gradient-to-r from-[#B8DAFF] to-[#1A6ECA] bg-clip-text text-transparent text-2xl sm:text-3xl font-bold mb-2">
              Welcome to VRX
            </h2>
            <p class="text-slate-300 text-sm sm:text-base">
              Utility Rewards Ecosystem
            </p>
          </div>

          <!-- Content -->
          <div class="space-y-4 mb-6">
            <!-- Important Notice -->
            <div class="rounded-xl p-4 bg-sky-500/10 border border-sky-400/20">
              <div class="flex items-start space-x-3">
                <svg class="h-6 w-6 text-sky-400 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div class="flex-1 min-w-0">
                  <h3 class="text-sky-300 font-semibold text-sm sm:text-base mb-1">Important Notice</h3>
                  <p class="text-slate-300 text-xs sm:text-sm leading-relaxed">
                    VRX is a <span class="font-semibold text-sky-300">utility token</span> that enables you to participate in the gaming rewards ecosystem and earn a share of community gaming rewards.
                  </p>
                </div>
              </div>
            </div>

            <!-- Terms and Conditions -->
            <div class="text-slate-300 text-sm sm:text-base leading-relaxed space-y-3">
              <p>
                Before proceeding, please review and accept our terms:
              </p>
              
              <!-- Links -->
              <div class="space-y-2 pl-4">
                <a 
                  href="https://www.starvara.com/website-terms-and-conditions" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  class="flex items-center space-x-2 text-sky-400 hover:text-sky-300 transition-colors group"
                >
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span class="group-hover:underline">Website Terms & Conditions</span>
                  <svg class="h-3 w-3 opacity-60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>

                <a 
                  href="https://www.starvara.com/privacy-policy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  class="flex items-center space-x-2 text-sky-400 hover:text-sky-300 transition-colors group"
                >
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                  <span class="group-hover:underline">Privacy Policy</span>
                  <svg class="h-3 w-3 opacity-60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
            </div>

            <!-- Checkbox -->
            <label class="flex items-start space-x-3 cursor-pointer group">
              <div class="relative flex items-center justify-center mt-0.5 flex-shrink-0">
                <input 
                  type="checkbox" 
                  v-model="accepted"
                  class="sr-only"
                />
                <div 
                  class="h-5 w-5 rounded border-2 transition-all duration-200 flex items-center justify-center"
                  :class="accepted 
                    ? 'bg-gradient-to-br from-sky-500 to-blue-600 border-sky-400 shadow-lg shadow-sky-500/30' 
                    : 'border-sky-400/40 bg-slate-900/50 group-hover:border-sky-400/60'"
                >
                  <!-- Checkmark Icon -->
                  <svg 
                    v-show="accepted"
                    class="h-3 w-3 text-white" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                    stroke-width="4"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <span class="text-slate-300 text-xs sm:text-sm leading-relaxed flex-1">
                I confirm that I have read and agree to the Terms & Conditions and Privacy Policy. I understand that VRX is a utility token for participating in the gaming rewards ecosystem.
              </span>
            </label>
          </div>

          <!-- Action Buttons -->
          <div class="flex flex-col sm:flex-row gap-3">
            <button 
              @click="handleDecline"
              class="flex-1 px-6 py-3 rounded-xl font-semibold text-slate-300 bg-slate-700/50 hover:bg-slate-700/70 border border-slate-600/50 focus:outline-none focus:ring-2 focus:ring-slate-500/50 transition-all duration-200"
            >
              Decline
            </button>
            <button 
              @click="handleAccept"
              :disabled="!accepted"
              :class="[
                'flex-1 px-6 py-3 rounded-xl font-semibold text-white transition-all duration-200 shadow-lg',
                accepted 
                  ? 'bg-gradient-to-r from-sky-600 to-blue-500 hover:from-sky-500 hover:to-blue-400 focus:outline-none focus:ring-2 focus:ring-sky-400/50 shadow-sky-500/20 hover:shadow-sky-500/40' 
                  : 'bg-slate-700/50 cursor-not-allowed opacity-50'
              ]"
            >
              Accept & Continue
            </button>
          </div>

          </div><!-- End scrollable content wrapper -->
        </div>
      </div>
      </div><!-- End scrollable modal container -->
    </div><!-- End modal wrapper with backdrop -->
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'

const STORAGE_KEY = 'vrx_terms_accepted'

const isOpen = ref(false)
const accepted = ref(false)

const emit = defineEmits(['accepted', 'declined'])

onMounted(() => {
  // Check if user has already accepted terms
  const hasAccepted = localStorage.getItem(STORAGE_KEY)
  if (!hasAccepted) {
    isOpen.value = true
  }
})

onUnmounted(() => {
  // Ensure body scroll is restored when component is unmounted
  const scrollY = document.body.style.top
  document.documentElement.style.overflow = ''
  document.documentElement.style.position = ''
  document.documentElement.style.top = ''
  document.documentElement.style.width = ''
  document.body.style.overflow = ''
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.width = ''
  document.body.style.paddingRight = ''
  if (scrollY) {
    window.scrollTo(0, parseInt(scrollY) * -1)
  }
})

// Prevent body scroll when modal is open
watch(isOpen, (newVal) => {
  if (newVal) {
    // Modal opened - prevent body scroll on all elements
    const scrollY = window.scrollY
    document.documentElement.style.overflow = 'hidden'
    document.documentElement.style.position = 'fixed'
    document.documentElement.style.top = `-${scrollY}px`
    document.documentElement.style.width = '100%'
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollY}px`
    document.body.style.width = '100%'
    document.body.style.paddingRight = '0px'
  } else {
    // Modal closed - restore body scroll
    const scrollY = document.body.style.top
    document.documentElement.style.overflow = ''
    document.documentElement.style.position = ''
    document.documentElement.style.top = ''
    document.documentElement.style.width = ''
    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    document.body.style.paddingRight = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
  }
}, { immediate: true })

function handleAccept() {
  if (!accepted.value) return
  
  // Save acceptance to localStorage
  localStorage.setItem(STORAGE_KEY, 'true')
  localStorage.setItem('vrx_terms_accepted_date', new Date().toISOString())
  
  isOpen.value = false
  emit('accepted')
}

function handleDecline() {
  // Optionally redirect away or show a message
  if (confirm('You must accept the terms to use this application. Would you like to review them again?')) {
    // Keep modal open
    accepted.value = false
  } else {
    // Redirect away or close the app
    window.location.href = 'https://www.starvara.com'
  }
}
</script>

<style scoped>
/* Glass Panel Effect */
.glass-panel {
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* Custom scrollbar for modal content */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.3);
  border-radius: 4px;
  margin: 8px 0;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(56, 189, 248, 0.3);
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(56, 189, 248, 0.5);
}

/* Firefox scrollbar styling */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(56, 189, 248, 0.3) rgba(15, 23, 42, 0.3);
}

/* Smooth scrolling */
.custom-scrollbar {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* Screen reader only (hides checkbox but keeps it accessible) */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Fade In Animation */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fade-in {
  animation: fade-in 0.2s ease-out;
}

/* Scale In Animation */
@keyframes scale-in {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.animate-scale-in {
  animation: scale-in 0.3s ease-out;
}
</style>

